  const toggleButton = document.querySelector(".main-sel-lang");
  const allCountryList = document.querySelector(".all-county-list");

  // Toggle dropdown on button click
  toggleButton.addEventListener("click", (event) => {
    event.stopPropagation(); // Prevent event from bubbling to document
    toggleButton.classList.toggle("open");

    if (toggleButton.classList.contains("open")) {
      openDropdown();
    } else {
      closeDropdown();
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", () => {
    if (toggleButton.classList.contains("open")) {
      closeDropdown();
      toggleButton.classList.remove("open");
    }
  });

  function openDropdown() {
    allCountryList.style.visibility = "visible";
    allCountryList.classList.add("open");
  }

  function closeDropdown() {
    allCountryList.classList.remove("open");
    setTimeout(() => {
      if (!allCountryList.classList.contains("open")) {
        allCountryList.style.visibility = "hidden";
      }
    }, 300);
  }